import React from "react";
import { Link } from "react-router-dom";

export default function Foot() {
  return (
    <>
      <footer className="footer-bg text-light pt-5">
        <div className="container">
          <div className="row py-4">
            <div className="col-md-4 mb-3">
              <h5 className="footer-title mb-3">About Us</h5>
              <p>
                South Eastern Railway Mixed Higher Secondary School, Adra is an important center of learning in this part of Purulia. Established by the British.
              </p>
            </div>
            <div className="col-md-4 mb-3">
              <h5 className="footer-title mb-3">Quick Links</h5>
              <ul className="footer-links list-unstyled">
                <li><Link to="/aboutus" className="footer-link">About Us</Link></li>
                <li><Link to="/mandatory" className="footer-link">Mandatory Disclosure</Link></li>
                <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
              </ul>
            </div>
            <div className="col-md-4 mb-3">
              <h5 className="footer-title mb-3">Contact Us</h5>
              <p>
                FMXG+2PC, Adra Station Road Junction Near Adra, West Bengal 723121
              </p>
            </div>
          </div>
        </div>
        <div className="footer-end text-center py-3">
          <h6 className="mb-0">&copy; 2023 SERMHSS | All Rights Reserved</h6>
        </div>
      </footer>
      <style>{`
        .footer-bg {
          background: linear-gradient(90deg, #232526 0%, #414345 100%);
        }
        .footer-title {
          font-weight: 600;
          font-size: 1.2rem;
          color: #ffd700;
        }
        .footer-links .footer-link {
          color: #cfd8dc;
          text-decoration: none;
          transition: color 0.2s;
          font-weight: 500;
          font-size: 1rem;
        }
        .footer-links .footer-link:hover {
          color: #ffd700;
          text-decoration: underline;
        }
        .footer-end {
          background: #222;
          color: #aaa;
        }
        @media (max-width: 768px) {
          .footer-title {
            font-size: 1rem;
          }
          .footer-links .footer-link {
            font-size: 0.95rem;
          }
        }
      `}</style>
    </>
  );
}